/*
 * Camada HTTP dos modulos PERSONALIZADOS (separada do lib/api.js do nucleo).
 * Regra Babita: chamadas so por aqui. Respostas { Error: 'msg' } ou dados puros.
 */
const BASE = (process.env.REACT_APP_API_URL || `${process.env.REACT_APP_SERVER_IP || 'http://192.168.0.204'}:${process.env.REACT_APP_SERVER_PORT || '3010'}`).replace(/\/+$/, '');

async function post(path, body) {
    try {
        const resp = await fetch(`${BASE}${path}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body || {})
        });
        const ct = resp.headers.get('content-type') || '';
        if (ct.includes('application/json')) {
            const j = await resp.json();
            if (!resp.ok && !j.Error) j.Error = `HTTP ${resp.status}`;
            return j;
        }
        const txt = await resp.text().catch(() => '');
        if (!resp.ok) return { Error: `HTTP ${resp.status}${txt ? ': ' + txt.slice(0, 240) : ''}` };
        return { raw: txt };
    } catch (e) {
        return { Error: e.message || 'Falha de rede.' };
    }
}

const P = '/Personalizado/Promocoes';

export const PromoConsultaFornecedores = (b) => post(`${P}/ConsultaFornecedores`, b);
export const PromoConsultaRevistas     = (b) => post(`${P}/ConsultaRevistas`, b);
export const PromoConsultaProdutos     = (b) => post(`${P}/ConsultaProdutos`, b);
export const PromoConsultaLojas        = (b) => post(`${P}/ConsultaLojas`, b);
export const PromoConferencia          = (b) => post(`${P}/Conferencia`, b);
export const PromoGeraArquivo          = (b) => post(`${P}/GeraArquivo`, b);
export const PromoEnviaArquivo         = (b) => post(`${P}/EnviarArquivo`, b);

const IR = '/Personalizado/ImportacaoRevistas';
export const ImportRevConsultaRevistas = (b) => post(`${IR}/ConsultaRevistas`, b);
export const ImportRevConferencia      = (b) => post(`${IR}/Conferencia`, b);
export const ImportRevVerificaMov      = (b) => post(`${IR}/VerificaMovimentacao`, b);
export const ImportRevPreviaDelete     = (b) => post(`${IR}/PreviaDelete`, b);
export const ImportRevExecutaDelete    = (b) => post(`${IR}/ExecutaDelete`, b);
export const ImportRevArquivos57       = (b) => post(`${IR}/ArquivosOrigem57`, b);
export const ImportRevConfFornecedores = (b) => post(`${IR}/ConferenciaFornecedores`, b);
export const ImportRevConferirImport   = (b) => post(`${IR}/ConferirImportacao`, b);
export const ImportRevStatusImport    = (b) => post(`${IR}/StatusImport`, b);
// Sem confirmar = previa (nao envia nada); com confirmar = sobe os produtos ao Sankhya.
export const ImportRevEnviarSankhya   = (b) => post(`${IR}/EnviarSankhya`, b);
// Sem confirmar = conferencia so-leitura do Sankhya (TGFEXC/TGFPRO/movimentacao); com confirmar +
// "APAGAR SANKHYA" = delete da importacao FINAL em segundo plano (job, acompanhar por StatusImport).
export const ImportRevDeleteSankhya   = (b) => post(`${IR}/DeleteSankhya`, b);
// Fornecedores (codigofab) de cada papel na aba Cadastro -- separa Regular e Plus no mesmo codigo.
export async function ImportRevFornecedoresPlanilha(file, extra) {
    const fd = new FormData();
    if (file) fd.append('arquivo', file);
    Object.entries(extra || {}).forEach(([k, v]) => fd.append(k, v));
    try { const r = await fetch(`${BASE}${IR}/FornecedoresPlanilha`, { method: 'POST', body: fd }); return await r.json(); }
    catch (e) { return { Error: e.message || 'Falha de rede.' }; }
}
export async function ImportRevArmazenar(file, extra) {
    const fd = new FormData();
    fd.append('arquivo', file);
    Object.entries(extra || {}).forEach(([k, v]) => fd.append(k, v));
    try { const r = await fetch(`${BASE}${IR}/Armazenar`, { method: 'POST', body: fd }); return await r.json(); }
    catch (e) { return { Error: e.message || 'Falha de rede.' }; }
}
export async function ImportRevGerar(file, extra) {
    const fd = new FormData();
    if (file) fd.append('arquivo', file);
    Object.entries(extra || {}).forEach(([k, v]) => fd.append(k, v));
    try { const r = await fetch(`${BASE}${IR}/Gerar`, { method: 'POST', body: fd }); return await r.json(); }
    catch (e) { return { Error: e.message || 'Falha de rede.' }; }
}
export async function ImportRevExecutaImport(file, extra) {
    const fd = new FormData();
    fd.append('arquivo', file);
    Object.entries(extra || {}).forEach(([k, v]) => fd.append(k, v));
    try {
        const r = await fetch(`${BASE}${IR}/ExecutaImport`, { method: 'POST', body: fd });
        return await r.json();
    } catch (e) { return { Error: e.message || 'Falha de rede.' }; }
}
const SU = '/Personalizado/SyncUsuarios';
export const SyncUsuCandidatos = (b) => post(`${SU}/Candidatos`, b);
export const SyncUsuImportar   = (b) => post(`${SU}/Importar`, b);
export async function ImportRevSalvaDescricoes(file, extra) {
    const fd = new FormData();
    if (file) fd.append('arquivo', file);
    Object.entries(extra || {}).forEach(([k, v]) => fd.append(k, v));
    try { const r = await fetch(`${BASE}${IR}/SalvaDescricoes`, { method: 'POST', body: fd }); return await r.json(); }
    catch (e) { return { Error: e.message || 'Falha de rede.' }; }
}

// Conferencia .xlsx: retorna um Blob (binario) ou { Error } se o backend recusar.
export async function PromoConferenciaXlsx(body) {
    try {
        const r = await fetch(`${BASE}${P}/GeraConferenciaXlsx`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body || {})
        });
        const ct = r.headers.get('content-type') || '';
        if (!r.ok || ct.includes('application/json')) {
            try { return await r.json(); } catch { return { Error: `HTTP ${r.status}` }; }
        }
        return await r.blob();
    } catch (e) {
        return { Error: e.message || 'Falha de rede.' };
    }
}

// Importar planilha de itens (.xlsx) no escopo "Por SKUs" -> identifica os produtos participantes.
export async function PromoImportarSkus(file, extra) {
    const fd = new FormData();
    fd.append('arquivo', file);
    Object.entries(extra || {}).forEach(([k, v]) => fd.append(k, v));
    try { const r = await fetch(`${BASE}${P}/ImportarSkus`, { method: 'POST', body: fd }); return await r.json(); }
    catch (e) { return { Error: e.message || 'Falha de rede.' }; }
}
